import './purchase-subscription-info.scss';
import { useTranslation } from 'react-i18next';
import { getSubscriptionImage } from '../../../../utility/functions/getSubscriptionImage';
import { SubscriptionManagement } from '../../../../store/SubscriptionsManagement/subscriptionsManagementTypes';

interface Props {
  subscription: SubscriptionManagement;
}

const PurchaseSubscriptionInfo = ({ subscription }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="purchase-subscription-info">
      <div className="purchase-subscription-info-name-title">
        {subscription.name}
      </div>
      <div className="purchase-subscription-info-image">
        <img
          src={getSubscriptionImage(subscription)}
          alt="Subscription image"
        />
      </div>
      <div className="purchase-subscription-info-description">
        {subscription.description || 'No description'}
      </div>
    </div>
  );
};

export default PurchaseSubscriptionInfo;
